module.exports = __webpack_public_path__ + "static/img/njfw.bed637be.png";